/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Ai_Data_To_ListingInputs */

const en_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply AI Data to Listing`)
};

const es_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar datos de IA al anuncio`)
};

const fr_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer les données IA à l'annonce`)
};

const de_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Daten auf Inserat anwenden`)
};

const ja_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIデータを出品に適用する`)
};

const zh_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 AI 数据应用至商品`)
};

const ar_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق بيانات الذكاء الاصطناعي على الإعلان`)
};

const id_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan Data AI ke Listing`)
};

const it_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica i Dati IA all'Annuncio`)
};

const ru_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить данные ИИ к объявлению`)
};

const pt_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar Dados da IA ao Anúncio`)
};

const ko_apply_ai_data_to_listing = /** @type {(inputs: Apply_Ai_Data_To_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 정보에 AI 데이터 적용`)
};

/**
* | output |
* | --- |
* | "Apply AI Data to Listing" |
*
* @param {Apply_Ai_Data_To_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const apply_ai_data_to_listing = /** @type {((inputs?: Apply_Ai_Data_To_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Ai_Data_To_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apply_ai_data_to_listing(inputs)
	if (locale === "es") return es_apply_ai_data_to_listing(inputs)
	if (locale === "fr") return fr_apply_ai_data_to_listing(inputs)
	if (locale === "de") return de_apply_ai_data_to_listing(inputs)
	if (locale === "ja") return ja_apply_ai_data_to_listing(inputs)
	if (locale === "zh") return zh_apply_ai_data_to_listing(inputs)
	if (locale === "ar") return ar_apply_ai_data_to_listing(inputs)
	if (locale === "id") return id_apply_ai_data_to_listing(inputs)
	if (locale === "it") return it_apply_ai_data_to_listing(inputs)
	if (locale === "ru") return ru_apply_ai_data_to_listing(inputs)
	if (locale === "pt") return pt_apply_ai_data_to_listing(inputs)
	return ko_apply_ai_data_to_listing(inputs)
});